module.exports = __webpack_public_path__ + "ffba7aa2431c932313230eaa7fccbf0b.pdf";